// user.module
export const SET_USER = "setUser"